(function () {
  function slugify(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/[\s-]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 80);
  }

  function buildArticleToc(root) {
    var body = root.querySelector('[data-swe-article-body]');
    var toc = root.querySelector('[data-swe-article-toc]');
    var list = toc && toc.querySelector('[data-swe-article-toc-list]');

    if (!body || !toc || !list) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
    if (headings.length < 3) return;

    var usedIds = {};
    var activeNestedList = null;

    headings.forEach(function (heading, index) {
      var label = heading.textContent.trim();
      if (!label) return;

      var baseId = heading.id || slugify(label) || 'section-' + (index + 1);
      var uniqueId = baseId;
      var suffix = 2;

      while (usedIds[uniqueId] || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
        uniqueId = baseId + '-' + suffix;
        suffix += 1;
      }

      usedIds[uniqueId] = true;
      heading.id = uniqueId;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + uniqueId;
      link.textContent = label;
      item.appendChild(link);

      if (heading.tagName === 'H2') {
        list.appendChild(item);
        activeNestedList = null;
        return;
      }

      if (!activeNestedList) {
        activeNestedList = document.createElement('ol');
        var lastTopItem = list.lastElementChild;
        if (lastTopItem) {
          lastTopItem.appendChild(activeNestedList);
        } else {
          list.appendChild(activeNestedList);
        }
      }

      activeNestedList.appendChild(item);
    });

    if (list.children.length) toc.hidden = false;
  }

  function initialize() {
    document.querySelectorAll('[data-swe-article-framework]').forEach(buildArticleToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
